import i18n from "i18next";
import languagedetector from "i18next-browser-languagedetector";
import backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

i18n.use(languagedetector)
    .use(backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: true,
        fallbackLng: "en", // use en if detected lng is not available
        load: 'languageOnly',
        backend: {
            // build id avoids serving translations cached from a previous deploy
            loadPath: '/locales/{{lng}}.json' + (process.env.REACT_APP_BUILD_ID ? `?v=${process.env.REACT_APP_BUILD_ID}` : '')
        },
        saveMissing: true, // send not translated keys to endpoint
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;